import React from "react";
import {TopPicksComponent} from "../../../../../components/ai-list/top-picks.component";
import {ApiListBaseModel} from "../api-list-base.model";

export class TopPicksListModel extends ApiListBaseModel {

    protected _shouldBeDisplayed(): boolean {
        if(!this.services.aiEngine.aiRecommendedGames.isInitialized) {
            return super._shouldBeDisplayed();
        }

        return super._shouldBeDisplayed() && this._getGameTypes().length > 0;
    }

    protected _getGameTypes(): number[] {
        return this.services.aiEngine.aiRecommendedGames?.gameTypes || [];
    }

    protected _getTitleTranslationParams() {
        return this.services.user.userData.firstName;
    }

    get aiEngine(): string {
        return this.services.aiEngine.aiRecommendedGames?.engine || '';
    }

    _renderList(listPosition: number): React.ReactElement | null {
        return (<TopPicksComponent key={this.listKey} viewModel={this} listPosition={listPosition}/>);
    }
}